module.exports = __webpack_public_path__ + "media/images/sports_icons/028-running-e635262860c6759a13615b7818150584.png";